import { connect } from 'react-redux'
import * as actions from '../../../actions'
import * as api from '../../../actions/api'
import { ChatCard } from '../../../components'
import { WID, getWord } from '../../../constants/Language';

const mapStateToProps = (state, ownProps) => {
  const { message, chatRooms } = state.chatCard
  const { isVisibleChatCard } = state.chatMenu
  const { user } = state.authentication
  const { language } = state.user
  var disabledSendButton, chatRoom
  if (!message || message > 100){
    disabledSendButton = true
  }
  else {
    disabledSendButton = false
  }
  chatRoom = null
  if (chatRooms[ownProps.liveId]){
    chatRoom = chatRooms[ownProps.liveId]
  }
  return ({
    user,
    message,
    chatRooms,
    chatRoom,
    disabledSendButton,
    isVisibleChatCard,
    language,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
    handleTextChange: (name) => (event) => {
      dispatch(actions.chatCard.changedText(name, event.target.value))
    },
    handleClickSendButton: () => {
      dispatch(api.live.sendMessage(ownProps.liveId))
      dispatch(actions.chatCard.changedText('message', ''))
    },
    handleKeyDown: (event) => {
      if (event.keyCode === 13){
        dispatch(api.live.sendMessage(ownProps.liveId))
        dispatch(actions.chatCard.changedText('message', ''))
      }
    },
    handleOpenBoard: (boardContext, analyzeId, language) => () => {
      dispatch(actions.chatCard.openBoard(ownProps.bid, ownProps.liveId, boardContext, analyzeId))
      ownProps.onOpenBoard(analyzeId)
      dispatch(actions.snackbar.notify(getWord(WID.CHAT_CARD.NOTIFY_OPEN_THE_ANALYSIS_BOARD, language), 'info'))
    },
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ChatCard)



// WEBPACK FOOTER //
// ./src/containers/Common/Chat/ChatCard.js